// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpProposEspec extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_propos_espec";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpProposEspec {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Propòsits especials",
                "cz": "Zvláštní účely",
                "da": "Særlige formål",
                "de": "Besondere Zwecke",
                "en": "Special purposes",
                "eu-ES": "Helburu bereziak",
                "fi": "Erityistarkoitukset",
                "fr": "Finalités spéciales",
                "ga-ES": "Propósitos especiais",
                "hi": "विशेष प्रयोजन",
                "hu": "Speciális célok",
                "it": "Propositi Speciali",
                "no": "Spesielle formål",
                "nl": "Bijzondere doeleinden",
                "pl": "Specjalne cele",
                "pt": "Objetivos especiais",
                "ro": "Scopuri speciale",
                "ru": "Специальные соглашения",
                "sv": "Särskilda syften",
                "sk": "Špeciálne účely"
            },
            "defecto": "Propósitos especiales"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
